import { Injectable } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { BookingsStateService } from './bookings-state.service';

@Injectable({
  providedIn: 'root'
})
export class BookingsNavigationService {

  constructor(
    private router: Router,
    private stateService: BookingsStateService
  ) { }

  navigateToDetail(id: number): void {
    const currentState = this.stateService.getCurrentState();
    const queryParams: any = this.stateService.stateToQueryParams(currentState);

    this.router.navigate(['/bookings', id], {
      queryParams
    });
  }

  /** Abre el detalle en una nueva pestaña (misma URL y query params que navigateToDetail). */
  openDetailInNewTab(id: number): void {
    const currentState = this.stateService.getCurrentState();
    const queryParams: any = this.stateService.stateToQueryParams(currentState);
    const urlTree = this.router.createUrlTree(['/bookings', id], {
      queryParams,
    });
    const url = this.router.serializeUrl(urlTree);
    window.open(url, '_blank', 'noopener,noreferrer');
  }

  backToList(): void {
    const currentState = this.stateService.getCurrentState();
    const queryParams = this.stateService.stateToQueryParams(currentState);

    this.router.navigate(['/bookings'], {
      queryParams
    });
  }

  applyFilters(): void {
    const currentState = this.stateService.getCurrentState();
    const queryParams = this.stateService.stateToQueryParams(currentState);

    this.router.navigate([], {
      relativeTo: this.getActivatedRoute(),
      queryParams,
      queryParamsHandling: 'replace'
    });
  }

  loadStateFromUrl(route: ActivatedRoute): boolean {
    const queryParams = route.snapshot.queryParams;

    if (this.hasValidQueryParams(queryParams)) {
      const state = this.stateService.queryParamsToState(queryParams);
      this.stateService.updateState(state);
      return true;
    }

    return false;
  }

  clearFilters(): void {
    this.stateService.clearState();

    this.router.navigate([], {
      relativeTo: this.getActivatedRoute(),
      queryParams: {},
      queryParamsHandling: 'replace'
    });
  }

  private hasValidQueryParams(params: any): boolean {
    // Logic to check if there are actual filter params
    const keys = Object.keys(params);
    return keys.length > 0;
  }

  private getActivatedRoute(): ActivatedRoute {
    let route = this.router.routerState.root;
    while (route.firstChild) {
      route = route.firstChild;
    }
    return route;
  }
}
